import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL CHANNELS
export const channelList = (params = '') => Http.get(`/marketing-ad-channels${serialize(params)}`)
export const channelCreate = (params = '') => Http.post('/marketing-ad-channels', params)
export const channelByID = (params = '') => Http.get(`/marketing-ad-channels/${params}`)
export const channelUpdate = (params = '') => Http.put(`/marketing-ad-channels/${params.id}`, params)
export const channelDestroy = (params = '') => Http.delete(`/marketing-ad-channels/${params.id}`)
